import { render, staticRenderFns } from "./FileSelectorDialog.vue?vue&type=template&id=e8733672&"
import script from "./FileSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./FileSelectorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports